import React from 'react';
import { FaPlane, FaArrowRight, FaCamera, FaGlobe, FaRocket, FaGraduationCap } from 'react-icons/fa';
import { indiaPosts } from '../data/indiaData';
import './IndiaHighlightSection.css';

export default function IndiaHighlightSection({ onOpenIndiaVisit }) {
  return (
    <section id="india-visit-preview" className="sec india-highlight-sec">
      <div className="sec-inner">
        <div className="sec-label">INTERNATIONAL MOBILITY PROGRAMME 2026</div>

        <div className="india-preview-header">
          <div>
            <h2 className="sec-title">
              From Jaffna to India <em><FaPlane style={{ fontSize: '0.6em', verticalAlign: 'middle' }} /></em>
            </h2>
            <p className="sec-desc">
              Selected among Northern UNI's <strong>Top Performing 12 Students</strong> for a fully funded 
              1-week international exposure programme at <strong>SIMATS Saveetha University, Chennai</strong>.
            </p>
          </div>

          <button className="btn-blk btn-india-cta" onClick={onOpenIndiaVisit}>
            Open Full Journal & Gallery <FaArrowRight />
          </button>
        </div>

        {/* Featured Posts Preview Cards */}
        <div className="india-preview-grid">
          {indiaPosts.map((post, idx) => {
            const firstImgUrl = `${encodeURI(post.imageFolder)}/${post.images[0].filename}`;
            return (
              <div 
                key={post.id} 
                className="india-preview-card"
                onClick={onOpenIndiaVisit}
              >
                <div className="preview-img-wrapper">
                  <img src={firstImgUrl} alt={post.title} loading="lazy" decoding="async" />
                  <span className="preview-badge">{post.badge}</span>
                  <span className="preview-photo-count"><FaCamera /> {post.images.length}</span>
                </div>

                <div className="preview-card-body">
                  <div className="preview-loc">{post.location}</div>
                  <h3 className="preview-card-title">{post.title}</h3>
                  <p className="preview-card-sub">{post.subtitle}</p>
                  
                  <div className="preview-read-more">
                    Read Article & View Photos <FaArrowRight />
                  </div>
                </div>
              </div>
            );
          })}

          {/* Teaser upcoming days card */}
          <div 
            className="india-preview-card teaser"
            onClick={onOpenIndiaVisit}
          >
            <div className="teaser-content">
              <FaRocket className="teaser-cta-icon" />
              <span className="teaser-pill">MORE CHAPTERS</span>
              <h3>Upcoming Chapters & Final Presentation</h3>
              <p>Industrial visits, drone research labs, cultural experiences & graduation showcase across Chennai.</p>
              <span className="btn-ghost-sm">Explore All Posts <FaArrowRight /></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
